import React, { Component } from 'react';

import { objToFen } from 'chessboard-element';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/styles';
import settings from '../../settings';
import { parseFenFromUrl } from '../../utils';


const styles = theme => ({
  container: {
    marginTop: 60,  // TODO: remember that this is just for injecting the page as iframe into browser extension
    maxWidth: 600, // TODO: set this to 1600 maybe?
    margin: '0 auto',
    justifyContent: 'space-evenly',
    backgroundColor: 'rgb(237, 235, 233)',
  },
  topBar: {
  },
  actionsContainer: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  switchWrapper: {
    marginLeft: 8,
    marginRight: 12,
    display: 'flex',
    flexDirection: 'column',
    marginTop: -4,
    width: 80,
  },
  buttonWrapper: {
    marginLeft: 0,
    marginRight: 5,
  },
  button: {
    textTransform: 'none',
  },
  optionsContainer: {
  },
});

const START_POSITION = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR';

class BoardPositionOnlyEditor extends Component {
  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(props.location.search);

    const paramPosition = searchParams.get('position');
    this.initPosition = parseFenFromUrl(paramPosition ?? props.match?.params.position ?? START_POSITION);
    this.color = searchParams.get('color') === 'black' ? 'black' : 'white';
    this.board = null;
  }

  componentDidMount() {
    this.board.addEventListener('change', this.onBoardUpdate);
  }

  componentWillUnmount() {
    this.board?.removeEventListener('change', this.onBoardUpdate);
  }

  // The event includes the new position before chessboard-element updates
  // its property. Publish that exact value, with no timer or stale URL window.
  onBoardUpdate = event => this.updateUrl(objToFen(event.detail.value));

  updateUrl = (position = this.board.fen()) => {
    const params = new URLSearchParams(window.location.search);
    params.delete('position');
    const query = params.toString();
    window.history.replaceState(window.history.state, '', `${settings.routes.BOARD_POSITION_ONLY_EDITOR}/${position}${query ? '?' + query : ''}`);
  }

  clearBoard = () => {
    this.board.setPosition({});
    this.updateUrl();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.topBar}>
          <div className={classes.actionsContainer}>
            <FormControlLabel
              className={classes.buttonWrapper}
              control={
                <Button
                className={classes.button}
                size="small"
                variant="outlined"
                onClick={this.clearBoard}
              >Clear Board</Button>
              }
             />
          </div>
        </div>
        { /* in chess-board we modify state directly without setState to avoid infinite loop of update-render */}
        <chess-board
          position={this.initPosition}
          style={{ width: '100%' }}
          orientation={this.color}
          aria-label="Edit chess position"
          draggable-pieces
          spare-pieces
          drop-off-board="trash"
          ref={(e) => this.board = e}>
        </chess-board>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(BoardPositionOnlyEditor));
